// =============================================================================
// Find Your...
// =============================================================================

$('document').ready(() => {
    const handleLinkClick = type => {
        return event => {
            event.preventDefault();
            $(event.target).toggleClass('active');
            $('#find-your-' + type).toggleClass('active');
        };
    };

    $('[href="#find-your-sport"]').on('click', handleLinkClick('sport'));
    $('[href="#find-your-club"]').on('click', handleLinkClick('club'));
});



// WEBPACK FOOTER //
// ./public/themes/masuri/assets/js/library/FindYour.js